import { render } from "./VideoPage.vue?vue&type=template&id=b16f64d4&scoped=true"
import script from "@/assets/js/video.js?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/video.js?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/video.css?vue&type=style&index=0&id=b16f64d4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b16f64d4"]])

export default __exports__